import { useState, useEffect } from "react";
import styles from "./reset-password.module.css";
import Spinner from "components/functional/spinner";
import instance from "services/api";
import { ToastComponent } from "services/toast.service";
import LanguageSelector from "components/functional/language-selector";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router";

const ResetPassword = () => {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});

  const { token } = useParams();
  const navigate = useNavigate();

  const checkResetPasswordToken = async () => {
    try {
      setLoading(true);
      const response = await instance.get(`/password/${token}`);
      setData(response.data);
    } catch (error) {
      navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  const updatePassword = async () => {
    if (!password) {
      setError(true);
      return;
    }

    try {
      setLoading(true);
      await instance.put(`/password/reset-password/${token}`, {
        email: data.email,
        password,
      });
      navigate("/reset-password-success");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkResetPasswordToken();
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className={styles.wrapper}>
      <ToastComponent />
      <div className={styles.container}>
        <header className={`${styles.header} mb-48`}>
          <img src="/logo.png" width="40" height="38" alt="" />
          <LanguageSelector />
        </header>
        <section className={styles.content}>
          <div className={styles.description}>
            <h1 className="title-1">
              {t("forgot-password.reset-password.title")}
            </h1>
            <p className="subtitle-1-variant">
              {t("forgot-password.reset-password.description")}
            </p>
          </div>
          <div className="form-group">
            <label htmlFor="email" className="required">
              {t("forgot-password.reset-password.input.title")}
            </label>
            <input
              type="password"
              autoComplete="new-password"
              required
              id="password"
              value={password}
              placeholder={t(
                "forgot-password.reset-password.input.placeholder"
              )}
              data-testid="password-input"
              onChange={(e) => {
                setPassword(e.target.value);
                setError(false);
              }}
              className={error && "error"}
            />
            {error && <p className="error-message">{t("errors.required")}</p>}
          </div>
          <button
            onClick={updatePassword}
            data-testid="update-password-button"
            className={`btn btn--primary ${styles.button}`}
          >
            {t("forgot-password.reset-password.button")}
            {loading && <Spinner className="action-loader" />}
          </button>
        </section>
      </div>
    </div>
  );
};

export default ResetPassword;
